import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getDisplayImageUrl } from '../../utils/imageUrl';
import DonationForm from '../Donate/DonationForm';

const HomePageEvents = () => {
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get(`${apiUrl}/events`);
                const upcomingEvents = response.data.filter(event => event.isUpcoming === true);
                setEvents(upcomingEvents);
            } catch (err) {
                console.error('Error fetching events:', err);
            }
        };

        fetchEvents();
    }, []);

   const openWindow = (id) => {
    navigate(`/events/${id}`);
    window.scrollTo(0, 0);
  };

    return (
        <div>
            <style>{`
                @media (max-width: 900px) {
                    .events-donate-grid {
                        grid-template-columns: 1fr !important;
                    }
                }
            `}</style>
            <section style={{ 
                background: 'linear-gradient(180deg, #e8f4f6 0%, #f0f8fa 100%)',
                padding: '50px 0',
                position: 'relative',
            }}>
                <div className="w-100 position-relative">
                    <div className="container">
                        {/* Two columns: Events (left) | Donation form (right) */}
                        <div 
                            className="events-donate-grid"
                            style={{ 
                                display: 'grid',
                                gridTemplateColumns: '1fr 380px',
                                gap: '32px',
                                maxWidth: '1200px',
                                margin: '0 auto',
                                alignItems: 'start',
                            }}
                        >
                            {/* Left: Upcoming Events */}
                            <div className="event-wrap res-row w-100">
                                <h2 style={{ 
                                    color: '#0095b3', 
                                    fontSize: '1.75rem', 
                                    fontWeight: '700', 
                                    marginBottom: '8px',
                                    letterSpacing: '-0.5px',
                                }}>
                                    Upcoming Events
                                </h2>
                                <div style={{
                                    width: '50px',
                                    height: '3px',
                                    background: 'linear-gradient(90deg, #0095b3, #00b8d4)',
                                    marginBottom: '24px',
                                    borderRadius: '2px',
                                }} />
                                <div 
                                    style={{ 
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '20px',
                                    }}
                                >
                                {events.length === 0 ? (
                                    <div style={{ marginBottom: '30px', width: '100%', maxWidth: '400px' }}>
                                        <div className="event-box w-100 position-relative" style={{ 
                                            borderRadius: '24px', 
                                            overflow: 'hidden', 
                                            background: '#ffffff',
                                            boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                                            padding: '40px',
                                            textAlign: 'center'
                                        }}>
                                            <div style={{ 
                                                fontSize: '3rem', 
                                                color: '#0095b3',
                                                marginBottom: '20px',
                                                opacity: 0.5
                                            }}>
                                                <i className="fas fa-calendar-alt"></i>
                                            </div>
                                            <h3 style={{ color: '#333', fontWeight: '700', marginBottom: '12px' }}>
                                                No Upcoming Events
                                            </h3>
                                            <p style={{ color: '#666', fontSize: '1rem' }}>
                                                We will update soon!
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    events.map((event, index) => (
                                        <div key={index} style={{ flex: '0 1 320px', maxWidth: '380px', minWidth: '280px' }}>
                                            <div 
                                                className="event-box w-100 position-relative" 
                                                style={{ 
                                                    borderRadius: '12px',
                                                    overflow: 'hidden',
                                                    background: '#ffffff',
                                                    boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                                                    transition: 'all 0.3s ease',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => openWindow(event.id)}
                                            >
                                                <div className="event-img position-relative w-100" style={{ 
                                                    height: '260px',
                                                    background: '#f0f0f0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    overflow: 'hidden',
                                                }}>
                                                    <img 
                                                        style={{ 
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'contain',
                                                            transition: 'transform 0.5s ease',
                                                            display: 'block',
                                                        }} 
                                                        className="img-fluid w-100" 
                                                        src={getDisplayImageUrl(event.imageUrl, { apiBaseUrl: apiUrl })} 
                                                        alt={event.title}
                                                    />
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "12px",
                                                            right: "12px",
                                                            background: "#FF0000",
                                                            color: "white",
                                                            padding: "5px 12px",
                                                            borderRadius: "4px",
                                                            fontSize: "0.7rem",
                                                            fontWeight: "700",
                                                            letterSpacing: "1px",
                                                            textTransform: "uppercase",
                                                        }}
                                                    >
                                                        Upcoming
                                                    </div>
                                                </div>
                                                <div className="event-info position-relative w-100" style={{ 
                                                    background: '#ffffff',
                                                    padding: '20px',
                                                }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginBottom: '8px',
                                                        color: '#0095b3',
                                                        fontSize: '0.85rem',
                                                        fontWeight: '600',
                                                    }}>
                                                        <i className="fas fa-map-marker-alt" style={{ marginRight: "6px", fontSize: '0.8rem' }}></i>
                                                        <span>{event.location}</span>
                                                    </div>
                                                    <h3 className="mb-0" style={{ marginBottom: '14px' }}>
                                                        <span style={{ 
                                                            color: '#222',
                                                            fontSize: '1.25rem',
                                                            fontWeight: '700',
                                                            lineHeight: '1.3',
                                                            display: 'block',
                                                        }}>
                                                            {event.title}
                                                        </span>
                                                    </h3>
                                                    <button
                                                        style={{
                                                            marginTop: "0",
                                                            background: "#0095b3",
                                                            color: "white",
                                                            padding: "10px 24px",
                                                            borderRadius: "6px",
                                                            cursor: 'pointer',
                                                            border: 'none',
                                                            fontWeight: '600',
                                                            fontSize: '0.9rem',
                                                            transition: 'all 0.3s ease',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            width: '100%',
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            openWindow(event.id);
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.background = "#00b8d4";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.background = "#0095b3";
                                                        }}
                                                    >
                                                        Register Now
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                                </div>
                            </div>

                            {/* Right: Donation Form */}
                            <div style={{ position: 'sticky', top: '24px' }}>
                                <h2 style={{ 
                                    color: '#0095b3', 
                                    fontSize: '1.75rem', 
                                    fontWeight: '700', 
                                    marginBottom: '8px',
                                    letterSpacing: '-0.5px',
                                }}>
                                    Donate
                                </h2>
                                <div style={{
                                    width: '50px',
                                    height: '3px',
                                    background: 'linear-gradient(90deg, #0095b3, #00b8d4)',
                                    marginBottom: '24px',
                                    borderRadius: '2px',
                                }} />
                                <DonationForm compact hideTitle />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomePageEvents;
